// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ConfirmationModal-cls1___d865fbc89b5c50565b6{/*!*/}.ConfirmationModal-cls2___60163e4896e5ca9240b{align-items:center;display:flex;justify-content:space-between}.ConfirmationModal-cls2___60163e4896e5ca9240b.ConfirmationModal-border___333011248da3c82d2ae{border-bottom:1px solid #dddde2;margin-bottom:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ConfirmationModal-cls1___d865fbc89b5c50565b6",
	"cls2": "ConfirmationModal-cls2___60163e4896e5ca9240b ConfirmationModal-cls1___d865fbc89b5c50565b6",
	"border": "ConfirmationModal-border___333011248da3c82d2ae"
};
export default ___CSS_LOADER_EXPORT___;
